import classNames from "classnames";
import React, {
    HTMLAttributes, ReactElement,
} from "react";
import { RiHashtag } from "@remixicon/react";
import Styles from "../Table.module.scss";
import useTableData from "../base";
import Text from "../../text/Text";
import Badge from "../../badge/Badge";

export interface TableControlsSeparatorProps extends HTMLAttributes<HTMLDivElement> {
    label?: string;
}

const TableControlsRowCounter = React.forwardRef((
    args: TableControlsSeparatorProps,
    ref: React.ForwardedRef<HTMLDivElement>,
): ReactElement => {
    const {
        className,
        label,
        ...rest
    } = args;

    const data = useTableData().useData();

    return (
        <div
            className={classNames(Styles["row-counter"], className)}
            ref={ref}
            {...rest}
        >
            <RiHashtag />
            {" "}
            <Text
                as="span"
                textVariant="body-2-medium"
                colorVariant="body-secondary"
            >
                {label}
                :
            </Text>
            {" "}
            <Text
                as="span"
                textVariant="body-2-medium"
                colorVariant="dim"
            >
                {data?.length}
            </Text>

        </div>
    );
});

TableControlsRowCounter.defaultProps = {
    label: "Results",
};

export default TableControlsRowCounter;
